<div fxLayout="row" class="background">
    <div fxFlex="80" fxFlexOffset="10%">

        <section id="header">
            <h1 class="h1Header">ADMINISTRAR TIPOS DE COMERCIO</h1>
        </section>

        <section id="table">
            <mat-card class="mat-elevation-z0">
                <div>
                    <button mat-flat-button class="add-btn" (click)="addShopType()">Agregar nuevo</button>
                </div>

                <table mat-table [dataSource]="allStoreTypes" class="mat-elevation-z0">

                    <ng-container matColumnDef="image">
                        <th mat-header-cell *matHeaderCellDef class="table-header">IMAGEN</th>
                        <td mat-cell *matCellDef="let storeType"><img class="table-image" [src]="storeType.dsImage" />
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef class="table-header">NOMBRE</th>
                        <td mat-cell *matCellDef="let storeType"> {{storeType.dsName}} </td>
                    </ng-container>

                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef class="table-header">ESTADO</th>
                        <td mat-cell *matCellDef="let storeType">
                            <p [style.color]="storeType.isEnabled ? 'blue' : '#F44336'">{{storeType.isEnabled |
                                status}}
                            </p>
                            <button mat-flat-button
                                (click)="changeStoreTypeStatus(storeType.cdStoreType, storeType.isEnabled, storeType.dsName)"
                                [ngClass]="{'activate-btn': !storeType.isEnabled, 'deactivate-btn': storeType.isEnabled}">
                                {{storeType.isEnabled | changeStatus}}</button>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="option">
                        <th mat-header-cell *matHeaderCellDef class="table-header">OPCIONES</th>
                        <td mat-cell *matCellDef="let storeType">
                            <button mat-mini-fab class="edit-btn" (click)="editShopType(storeType.cdStoreType)">
                                <mat-icon>create</mat-icon>
                            </button>
                            <button mat-mini-fab class="delete-btn"
                                (click)="deleteShopType(storeType.cdStoreType, storeType.dsName)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>

            </mat-card>
        </section>
    </div>
</div>
